import { ClientTokenPayload, useAuthStore } from 'src/common/store'
import { onSignalREvent } from '../../signalRBus'
import { useClientContextStore } from 'src/client/stores'
import { useClientOnboarding } from 'src/client/hooks/useOnboarding'
import { router } from 'src/router'
import { SIGNAL_R_MESSAGES, SIGNAL_R_SCOPES } from 'src/signalR/types'

onSignalREvent(
  SIGNAL_R_SCOPES.system,
  SIGNAL_R_MESSAGES.portalRegistrationCreated,
  async (text) => {
    const authStore = useAuthStore()
    if (!authStore.isClient) return
    const clientContextStore = useClientContextStore()
    const eventFamilyId = text.split('_').pop()
    const loggedInFamilyId = (authStore.tokenPayload as ClientTokenPayload)
      ?.extension_FamilyId
    if (eventFamilyId !== loggedInFamilyId) return

    await clientContextStore.fetchFamilyDashboard()

    // Re-run the same onboarding/authorization gate ClientLayout.vue checks on
    // mount, so a live registration change (e.g. adding a child) kicks the
    // parent into onboarding immediately instead of only on next app open.
    const onboardingHook = useClientOnboarding()
    if (
      onboardingHook.isPendingAuthorization.value &&
      router.currentRoute.value.name !== 'client.pending.authorization'
    ) {
      void router.push({ name: 'client.pending.authorization' })
      return
    }

    const isOnboardingRequired = await onboardingHook.resolveIsOnboarding()
    if (
      isOnboardingRequired &&
      router.currentRoute.value.name !== 'client.onboarding'
    ) {
      void router.push({ name: 'client.onboarding' })
    }
  },
)
